(ns bleene.dag.api
  (:require
   [clojure.edn :as edn]
   [minorodata.connections.model :refer [->extract]]
   [minorodata.group.model :refer [->group]]
   [minorodata.sandbox.model :refer [->pipeline-dag ->pipeline-extract
                                     ->pipeline-transform]]
   [mold-http.core :refer [reg-event-http]]
   [re-frame.core :as re-frame]
   [re-posh.core :as re-posh]))

(defn fetch-graph-request [_ _]
  {:http-xhrio
   {:url "/api/dependency-graph/entity"}})

(defn fetch-graph-callback [_ [error resp]]
  (if (some? error)
    {:dispatch-n
     [[:app.events/add-snack :error "Failed to fetch the dag"]
      [:app.api/log :error "Failed to fetch the dag" error]]}

    (let [{:keys [nodes edges has-cycles edges-in-cycles]} resp]
      {:dispatch [:dag/set-raw-data {:nodes           nodes
                                     :edges           edges
                                     :has-cycles      has-cycles
                                     :edges-in-cycles edges-in-cycles}]})))

(reg-event-http
 :dag.api/fetch-graph
 fetch-graph-request
 fetch-graph-callback)


(defn load-search-request [_ [params]]
  {:http-xhrio
   {:id       :load-search-request
    :strategy :keep-latest
    :url      "/api/transformations/search"
    :method   :post
    :params   params}})


(defn load-search-callback [_ [error resp]]
  (if (some? error)
    {:dispatch
     [:app.api/log :error "Failed to complete search" error]}

    (let [{:keys [transforms groups parent-groups]} resp]
      {:dispatch-n [[:dag/set-raw-data {:transforms    (:data transforms)
                                        :groups        (:data groups)
                                        :parent-groups parent-groups}]
                    ;; some events require the old models to be in place
                    [:group/add-many (map ->group parent-groups)]
                    [:transformations-search/update
                     {:transformations-search/transforms (or (:data transforms) [])
                      :transformations-search/groups     (or (:data groups) [])}
                     {:replace true}]]})))


(reg-event-http
 :dag.api/load-search-results
 load-search-request
 load-search-callback)

(defn load-dag-metadata-request [_ [params]]
  {:http-xhrio
   {:id       :load-metadata-request
    :strategy :keep-latest
    :url      "/api/dependency-graph/entity/metadata"
    :params   params
    :cb-params params}})


(defn load-dag-metadata-callback [_ [error resp]]
  (if (some? error)
    {:dispatch
     [:app.api/log :error "Failed to complete fetching metadata" error]}

    (let [{:keys [transforms groups sources extracts]} resp
          dag-transforms (mapv #(->pipeline-transform (assoc % :id (:transform-id %))) transforms)]
      {:dispatch-n [[:extract/add-many (mapv ->extract extracts)]
                    [:pipeline-transform/add-many dag-transforms]
                    [:pipeline-extract/add-many (mapv #(->pipeline-extract (assoc % :id (:extract-id %))) extracts)]
                    [:dag/set-raw-data {:transforms    transforms
                                        :groups        groups
                                        :sources       sources
                                        :extracts      extracts}]]})))


(reg-event-http
 :dag.api/load-dag-metadata
 load-dag-metadata-request
 load-dag-metadata-callback)

(def search-params
  {:query      ""
   :pagination {:items-per-page 999999 :page 0}
   :filters    {:type :both}})

(re-frame/reg-event-fx
 :dag/load-dag-data
 (fn [_ [_ dag-id initial-focus-id]]
   (let [layout? @(re-posh/subscribe [:unleash/is-enabled "fe.manual-dag-layout"])]
     {:dispatch
      [:dag/set-loading true "Loading Graph"]

      :async-flow
      {:first-dispatch [:dag.api/fetch-graph]
       :rules [{:when     :seen?
                :events   :dag.api/fetch-graph-success
                :dispatch [:dag.api/load-dag-metadata search-params]}
               (when layout?
                 {:when     :seen?
                  :events   :dag.api/fetch-graph-success
                  :dispatch [:dag.api/fetch-layout]})
               {:when       :seen?
                :events     (if layout? [:dag.api/load-dag-metadata-success :dag.api/fetch-layout-success] :dag.api/load-dag-metadata-success)
                :dispatch-n [[:dag/convert-raw-data dag-id]
                             [:dag/set-loading false]
                             [:dag/filter-nodes dag-id]]
                :halt?      true}
               {:when     :seen?
                :events   :dag.api/load-dag-metadata-failure
                :dispatch [:dag/set-loading false]
                :halt?    true}]}})))


(defn create-transform-request [_ [dag-id {:keys [group-id name id]}]]
  {:http-xhrio
   {:url       (str "/api/transformations/" group-id "/transforms")
    :method    :post
    :params    {:name          name
                :command       ""
                :input-tables  []
                :output-tables []
                :status        :active
                :ignore-parser false
                :is-full       false
                :is-temp       false}
    :cb-params {:dag-id  dag-id
                :temp-id id}}})

(defn create-transform-callback [_ [error resp {:keys [dag-id temp-id]}]]
  (if (some? error)
    {:dispatch-n [[:app.events/add-snack :error "Failed to create transform"]
                  [:app.api/log :error "Failed to create transform" error]]}

    {:dispatch-n [[:dag/update-job dag-id temp-id (:data resp)]
                  [:app.events/add-snack :success "Transform created"]]}))

(reg-event-http
 :dag.api/create-transform
 create-transform-request
 create-transform-callback)


(re-frame/reg-event-fx
 :dag/create-transform
 (fn [_ [_ dag-id job]]
   {:dispatch
    [:dag/set-loading true "Saving new job"]

    :async-flow
    {:first-dispatch [:dag.api/create-transform dag-id job]
     :rules          [{:when     :seen?
                       :events   :dag.api/create-transform-complete
                       :dispatch [:dag/set-loading false]
                       :halt?    true}
                      {:when     :seen?
                       :events   :dag.api/create-transform-failure
                       :dispatch [:dag/set-loading false]
                       :halt?    true}]}}))


(re-frame/reg-event-fx
 :dag/delete-transform
 (fn [_ [_ group-id transform-id {:keys [on-success on-failure]}]]
   {:dispatch
    [:dag/set-loading true "Deleting job"]

    :async-flow
    {:first-dispatch [:transform.api/delete-transform {:group-id     group-id
                                                       :transform-id transform-id
                                                       :navigate?    false}]
     :rules          [{:when       :seen?
                       :events     :transform.api/delete-transform-complete
                       :dispatch-n [[:dag/set-loading false]
                                    on-success]
                       :halt?      true}
                      {:when       :seen?
                       :events     :transform.api/delete-transform-failure
                       :dispatch-n [[:dag/set-loading false]
                                    on-failure]
                       :halt?      true}]}}))

(re-frame/reg-event-fx
 :dag/delete-extract
 (fn [_ [_ source-id extract-id {:keys [on-success on-failure]}]]
   {:dispatch
    [:dag/set-loading true "Deleting job"]

    :async-flow
    {:first-dispatch [:connections.api/delete-extract source-id extract-id]
     :rules          [{:when       :seen?
                       :events     :connections.api/delete-extract-complete
                       :dispatch-n [[:dag/set-loading false]
                                    on-success]
                       :halt?      true}
                      {:when       :seen?
                       :events     :connections.api/delete-extract-failure
                       :dispatch-n [[:dag/set-loading false]
                                    on-failure]
                       :halt?      true}]}}))

(defn fetch-layout-request []
  {:http-xhrio
   {:url "/api/dependency-graph/layout"}})

(defn fetch-layout-callback [_ [error resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to fetch saved Pipelines layout"]}
    {:dispatch-n [[:dag/set-layout (some-> resp :layout edn/read-string)]
                  [:dag/set-sources-on-dag :default-dag (if (boolean? (:show-sources resp))
                                                          (:show-sources resp)
                                                          true)]
                  [:dag/filter-nodes :default-dag]]}))

(reg-event-http
 :dag.api/fetch-layout
 fetch-layout-request
 fetch-layout-callback)

(defn save-layout-request [_ [{:keys [layout show-sources]}]]
  {:http-xhrio
   {:method    "POST"
    :url       "/api/dependency-graph/layout"
    :params    {:layout (str layout)
                :show-sources show-sources}
    :cb-params {:layout       layout}}})

(defn save-layout-callback [_ [error _ {:keys [layout]}]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to save Pipelines layout"]}
    {:dispatch-n [[:dag/set-layout layout]
                  [:app.events/add-snack :success "Pipelines layout saved"]]}))

(reg-event-http
 :dag.api/save-layout
 save-layout-request
 save-layout-callback)


(defn fetch-available-dag-layouts-request []
  {:http-xhrio
   {:url "/api/dependency-graph/layouts"}})

(defn fetch-available-dag-layouts-callback [_ [error resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to fetch saved Pipelines layouts"]}
    {:dispatch-n [[:dag/set-available-dag-layouts (some-> resp :layouts)]]}))

(reg-event-http
 :dag.api/fetch-available-dag-layouts
 fetch-available-dag-layouts-request
 fetch-available-dag-layouts-callback)
